import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function luhnValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const value = control.value;

        // Empty value is handled by Validators.required
        if (!value) {
            return null;
        }

        // Remove dashes and whitespace
        const cardNumber = String(value)
            .replace(/-/g, '')
            .replace(/\s/g, '')
            .trim();

        // Must contain digits only
        if (!/^\d+$/.test(cardNumber)) {
            return {
                luhn: true
            };
        }

        let sum = 0;
        let shouldDouble = false;

        // Start from the right
        for (let i = cardNumber.length - 1; i >= 0; i--) {

            let digit = Number(cardNumber.charAt(i));

            if (shouldDouble) {
                digit *= 2;

                if (digit > 9) {
                    digit -= 9;
                }
            }

            sum += digit;
            shouldDouble = !shouldDouble;
        }

        return sum % 10 === 0
            ? null
            : { luhn: true };
    };
}